import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";
import { GraphDataMaker } from "../../../util/helper/graph";
import { MAX_RETURNING_TIME } from "../../../constants/limit";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.Returning}
		subHeader={I18n.t("user_retention")}
		fetchMain={ReportAction.fetchCounReturning}
		getAutoSelectItem={(items)=>{
			let searchLabel = Object.keys(items)[0];
			const time = GraphDataMaker.returningTimeLabel(searchLabel);
			return time;
		}}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingReturning.js